import React from "react"

const Error=()=>{
    return (
        <div className="flex justify-between items-center text-3xl font-mono text-white">
            Error-404 Not Found
        </div>
    )
}

export default Error;